import * as Action from '../action';

const initialState = {
  tappedTabIndex: 0,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Action.SET_CONTAINER_DETAIL_TAB_INDEX:
      return { ...state, tappedTabIndex: action.tappedTabIndex };
    default:
      return state;
  }
};
